import { JobsXingletWrapper } from '../../../jobs-xinglet';
import { SearchInspirationSkeleton } from './search-inspiration-skeleton';

export const SearchInspiration = JobsXingletWrapper(
  '@xing-com/crate-jobs-domain-search-inspiration',
  <SearchInspirationSkeleton />
);
